export default "__VITE_PUBLIC_ASSET__5aef2e52__"